/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userAmazonCatalogue.internal

import features.userAmazonCatalogue.models.UserRewardsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserAmazonCatalogueServiceImpl : UserAmazonCatalogueService {

    private val userAmazonCatalogueRequest = UserAmazonCatalogueRequest()

    override suspend fun getUserAmazonCatalogue(
        overrideHeaders : Map<String, String>?,
        pageNumber: Int,
        perPage: Int,
        keywords: String?,
        filters: String?    ): Result<UserRewardsModel> {
        return userAmazonCatalogueRequest.getUserAmazonCatalogue(
            overrideHeaders = overrideHeaders,
            pageNumber = pageNumber,
            perPage = perPage,
            keywords = keywords,
            filters = filters        ).toModel()
    }
}
